import { InventoryDecisionResult, InventoryWizardAnswers } from '~/types/inventoryWizard';

export function computeInventoryDecision(req: InventoryWizardAnswers): InventoryDecisionResult {
  if (req.recent_go_live) {
    return {
      decision: 'ESCALATE_TL_THEN_CM',
      reason: 'Campaign went live within the last 3 business days.',
    };
  }

  if (req.tier_1_or_2) {
    if (req.campaign_live) {
      if (req.request_over_50pct_month_within_next_3_months) {
        return {
          decision: 'ESCALATE_TL_THEN_CM',
          reason: 'Tier 1/2, live, request covers >50% of a calendar month within the next 3 months.',
        };
      }
      return {
        decision: 'UPDATE_INVENTORY',
        reason: 'Tier 1/2, live, request is <=50% of a calendar month within the next 3 months.',
      };
    }

    if (!req.request_full_month_or_over_50pct_calendar) {
      return {
        decision: 'UPDATE_INVENTORY',
        reason: 'Tier 1/2, not live, request is under a full month / 50% of the calendar.',
      };
    }

    if (req.at_least_30_days_availability_remaining) {
      return {
        decision: 'UPDATE_INVENTORY',
        reason: 'Tier 1/2, not live, large request, but >=30 days of availability remain.',
      };
    }

    if (req.has_bnbls) {
      return {
        decision: 'ESCALATE_CM',
        reason: 'Tier 1/2, not live, large request, <30 days remaining, BNBLs present.',
      };
    }

    return {
      decision: 'UPDATE_INVENTORY',
      reason: 'Tier 1/2, not live, large request, <30 days remaining, no BNBLs.',
    };
  }

  if (!req.campaign_live) {
    return {
      decision: 'UPDATE_INVENTORY',
      reason: 'Non-Tier 1/2, campaign not live.',
    };
  }

  if (req.request_full_month_or_over_50pct_calendar) {
    return {
      decision: 'ESCALATE_TL_THEN_CM',
      reason: 'Non-Tier 1/2, live, request covers a full month or >50% of the calendar.',
    };
  }

  return {
    decision: 'UPDATE_INVENTORY',
    reason: 'Non-Tier 1/2, live, request is under a full month / 50% of the calendar.',
  };
}
